import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import { iban, studentid } from "../../../sql/classy/types";
import {
  Field,
  Form,
  checkBox,
  constantField,
  textBox,
} from "trader.ts/ui.forms";
import { dyn, dynClass } from "trader.ts/ui";
import { renderSaveButton } from "../../client/savebutton";
import { rpc } from "trader.ts/network";

export function render(opts: {
  start_edit: boolean;
  schoolname: string;
  student: {
    id: studentid;
    iban: iban | null;
    name_on_iban: string;
    direct_debit_allowed: boolean;
  };
}): HTMLElement | HTMLElement[] {
  const editingS = new Source(opts.start_edit);

  const form = new Form({})
    .addField("direct_debit_allowed", [], () => {
      return checkBox({
        initialVal: opts.student.direct_debit_allowed,
        class: style.checkbox + style.input_like,
        label: "Ik geef %schoolname toestemming om betaalopdrachten rechtstreeks naar mijn bank te sturen".replace("%schoolname", opts.schoolname),
      });
    })
    .addField(
      "iban",
      ["direct_debit_allowed"],
      ({ direct_debit_allowed }): Promise<Field<string | null>> => {
        if (direct_debit_allowed) {
          return textBox({
            initialVal: opts.student.iban || "",
            label: "IBAN rekening",
          });
        } else {
          return constantField(opts.student.iban);
        }
      },
    )
    .addField(
      "name_on_iban",
      ["direct_debit_allowed"],
      ({ direct_debit_allowed }): Promise<Field<string>> => {
        if (direct_debit_allowed) {
          return textBox({
            initialVal: opts.student.name_on_iban || "",
            label: "Naam op rekening",
          });
        } else {
          return constantField(opts.student.name_on_iban);
        }
      },
    )
    .build({
      render: (fields) => (
        <div>
          {fields.direct_debit_allowed()}
          <div className={style.equal_columns}>
            {fields.iban()}
            {fields.name_on_iban()}
          </div>
        </div>
      ),
    });

  return (
    <div>
      {dynClass(
        editingS,
        (editing) => (editing ? "" : style.readonly_form),
        <section>{form.render()}</section>,
      )}
      {dyn(editingS, function (editing) {
        if (editing) {
          return (
            <div style="text-align: right;">
              {renderSaveButton({
                formS: form.s,
                save: (values) =>
                  rpc(routes.saveStudentDirectDebitInfoSpec, undefined, {
                    id: opts.student.id,
                    ...values,
                  }),
                reload: () => editingS.set(false),
              })}
            </div>
          );
        } else {
          return <span></span>;
        }
      })}
    </div>
  );
}
